import { useState, useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import Icons from './Icons'

const faqs = [
  {
    question: 'okb官网如何保障用户资产安全？',
    answer: 'okb官方网站采用军工级安全防护体系，包括：98%资产存储于离线冷钱包；多重签名技术确保每笔交易需多方验证；AI驱动的实时风控系统7x24小时监控；SOC 2国际安全认证；SSL加密传输保护数据；用户资产保险覆盖等全方位保障措施。',
  },
  {
    question: '什么是冷热钱包分离存储？',
    answer: '冷热钱包分离是将大部分数字资产（约98%）存储在完全离线的冷钱包中，与互联网物理隔离，彻底杜绝黑客攻击风险。只有少量用于日常交易的资产存放在热钱包，并通过严格的风控机制进行管理。这种存储方式是目前行业内最安全的资产保管方案。',
  },
  {
    question: 'okb平台支持哪些安全验证方式？',
    answer: 'okb官网支持多重安全验证：双因素认证（2FA）包括谷歌验证器和短信验证；生物识别技术如指纹和面部识别；设备绑定管理，新设备登录需额外验证；登录异常提醒；提现白名单设置；API密钥独立权限管理等，用户可根据需求灵活配置安全等级。',
  },
  {
    question: '如何防范钓鱼网站和诈骗？',
    answer: '请务必通过官方渠道访问okb官方网站。认准官方域名，谨防仿冒网站。开启官方APP的防钓鱼码功能，定期更换密码，不轻易点击陌生链接，不向任何人透露账户信息和验证码。如遇可疑情况，请立即联系官方客服核实。',
  },
  {
    question: '如果忘记密码或丢失2FA怎么办？',
    answer: 'okb官网提供完善的账户恢复机制。忘记密码可通过注册邮箱或手机号重置；丢失2FA验证器可通过绑定的备用邮箱或人工客服验证身份后解除。为确保安全，重置过程需要严格的身份验证，请提前绑定安全邮箱和手机号。',
  },
  {
    question: 'okb平台是否发生过安全事故？',
    answer: 'okb官网自创立以来，始终将用户资产安全放在首位，采用业界领先的安全技术和管理措施，至今保持零重大安全事故记录。平台定期进行第三方安全审计，持续优化安全防护体系，为全球5000万用户提供可信赖的数字资产交易服务。',
  },
]

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)
  const faqRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.faq-item',
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.4,
          stagger: 0.1,
          scrollTrigger: {
            trigger: faqRef.current,
            start: 'top 80%',
          },
        }
      )
    }, faqRef)

    return () => ctx.revert()
  }, [])

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section
      ref={faqRef}
      id="faq"
      className="section-padding relative overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0f] to-[#13131a]" />

      <div className="relative z-10 max-w-4xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="gradient-text">安全技术问答</span>
          </h2>
          <p className="text-[#8080a0] text-lg">
            关于okb官网安全保障的常见问题解答
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item cyber-border rounded-xl overflow-hidden"
            >
              <button
                className="w-full px-6 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-[rgba(255,0,255,0.02)] transition-colors"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-[#e0e0ff] font-medium pr-4">
                  {faq.question}
                </span>
                <span className={`text-[#ff00ff] transition-transform shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <Icons.ChevronDown />
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-4 text-[#8080a0] leading-relaxed border-t border-[rgba(255,0,255,0.1)] pt-4">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 text-center">
          <p className="text-[#8080a0] mb-4">
            还有其他问题？我们的客服团队随时为您服务
          </p>
          <a
            href="https://www.jsqkmfytwpn.com/join/1p9999"
            target="_blank"
            rel="noopener"
            className="btn-secondary inline-flex items-center gap-2"
          >
            联系客服
            <Icons.ArrowRight />
          </a>
        </div>
      </div>
    </section>
  )
}
